import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import CBMediaQuery from '../../shared/CBMediaQuery';
import '../../../App.css';
import { getStyle } from '../../../utils/utils';
import CBModal from '../../shared/CBModal';

class ChainCareServiceResponseModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleAccept = () => {
    const { acceptInvitation, invitation, closeModal } = this.props;
    acceptInvitation(invitation.id, {});
    closeModal();
  };

  handleDecline = () => {
    const { declineInvitation, invitation, closeModal } = this.props;
    declineInvitation(invitation.id);
    closeModal();
  };

  render() {
    const {
      modalIsOpen,
      closeModal,
      afterOpenModal,
      t,
      invitation,
    } = this.props;

    if (!invitation) {
      return null;
    }

    return (
      <CBMediaQuery>
        {screenSize => (
          <CBModal
            modalIsOpen={modalIsOpen}
            afterOpenModal={afterOpenModal}
            closeModal={this.handleDecline}
            title={t('chainCareServiceInvitationTitle')}
            descriptionText={t('chainCareServiceInvitationDescription', {
              chainName: invitation.chain_name || 'Ketju',
            })}
            cancelText={t('decline')}
            submitText={t('accept')}
            submitForm={this.handleAccept}
            isValid
          >
            <div style={getStyle(screenSize, styles, 'bodyContainer')}>
              <div style={getStyle(screenSize, styles, 'invitationDetails')}>
                <p style={getStyle(screenSize, styles, 'labelText')}>
                  {t('invitationFromLabel')}:
                </p>
                <p style={getStyle(screenSize, styles, 'valueText')}>
                  {invitation.chain_name || invitation.email}
                </p>
              </div>
              {invitation.title && (
                <div style={getStyle(screenSize, styles, 'messageSection')}>
                  <p style={getStyle(screenSize, styles, 'messageTitle')}>
                    {invitation.title}
                  </p>
                  {invitation.text && (
                    <p style={getStyle(screenSize, styles, 'messageText')}>
                      {invitation.text}
                    </p>
                  )}
                </div>
              )}
            </div>
          </CBModal>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 32px',
    },
    invitationDetails: {
      marginBottom: 16,
    },
    labelText: {
      color: '#666',
      fontSize: 12,
      marginBottom: 4,
    },
    valueText: {
      color: '#000',
      fontSize: 16,
      fontWeight: 500,
    },
    messageSection: {
      backgroundColor: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      marginTop: 16,
    },
    messageTitle: {
      color: '#000',
      fontSize: 14,
      fontWeight: 500,
      marginBottom: 8,
    },
    messageText: {
      color: '#333',
      fontSize: 14,
      lineHeight: 1.5,
      whiteSpace: 'pre-wrap',
    },
  },
  small: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 16px',
    },
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
  };
}

export default connect(
  mapStateToProps,
  {},
)(translate('ChainCareService')(ChainCareServiceResponseModal));
